export default {
  SOMETHING_WENT_WRONG: "Une erreur est survenue",
  PAGE_NOT_ALLOWED: "Vous n'êtes pas autorisé à accéder à cette page",
  FILE_UPLOAD_ERROR: "Erreur lors du chargement du fichier",
  SUPPLIER_X_HAS_X_MIN_PURCHASE: "Le fournisseur {supplierName} exige un minimum de commande de {minPurchase} par livraison. Il se pourrait que la commande soit refusée si vous n'atteignez pas ce montant.",
  SUPPLIER_X_HAS_X_MAX_PURCHASE: "Le fournisseur {supplierName} a un maximum de {maxPurchase} pour votre établissement. Veuillez-vous assurer d'avoir l'approbation de votre supérieur avant de valider cette commande.",
  INVALID_EXPECTED_DELIVERY_DATE:
    "La date de livraison prévue ne respecte pas les règles d'approvisionnement.",
  ESTABLISHMENT_NOT_ACTIVE:
    "Cet établissement est désactivé. Cette opération n'est pas autorisée.",
  WEEKLY_REPORT_WAGES_REQUIRED:
    "Les salaires de cette semaine ne sont pas saisis. Saisissez-les dans l'onglet « Détails » avant de valider le rapport.",
  ESTABLISHMENT_WEEKLY_REPORTS_DISABLED:
    "Cet établissement ne produit pas de rapports hebdomadaires. Cochez « Produit des rapports hebdomadaires » dans sa fiche pour en créer un.",
  PRODUCTION_ESTABLISHMENT_REQUIRED: "Choisissez l'établissement producteur.",
  TRANSFER_HAS_NO_ITEMS:
    "Ajoutez au moins un équipement avant de soumettre le transfert.",
  RETURN_DATE_REQUIRED_FOR_TEMPORARY_TRANSFER:
    "La date de retour est requise pour un transfert temporaire.",
  EQUIPMENT_ALREADY_ON_LOAN:
    "Un des équipements est déjà en prêt sur un autre transfert.",
  CANNOT_UPDATE_TRANSFER_NOT_DRAFT:
    "Un transfert qui n'est plus au statut brouillon ne peut pas être modifié.",
  CANNOT_ACCEPT_NON_SUBMITTED_TRANSFER:
    "Seul un transfert soumis peut être accepté.",
  SUBMITTER_CANNOT_ACCEPT_TRANSFER:
    "Vous ne pouvez pas accepter un transfert que vous avez soumis.",
  USER_NOT_ALLOWED_TO_ACCEPT_TRANSFER:
    "Vous n'êtes pas autorisé à accepter ce transfert.",
  USER_NOT_ALLOWED_TO_CANCEL_ACCEPTED_TRANSFER:
    "Vous n'êtes pas autorisé à annuler un transfert déjà accepté.",
  USER_NOT_ALLOWED_TO_SEND_TRANSFER:
    "Vous n'êtes pas autorisé à envoyer ce transfert par courriel.",
  USER_NOT_ALLOWED_TO_RETURN_TRANSFER:
    "Vous n'êtes pas autorisé à retourner ce transfert.",
  INTERNAL_ORDER_DELIVERY_DATE_REQUIRED:
    "Précisez la journée commandée que cette facture règle : c'est elle qui date la facture.",
  INTERNAL_ORDER_DELIVERY_DATE_OUT_OF_WEEK:
    "Cette journée n'appartient pas à la semaine de la commande interne.",
  INTERNAL_INVOICE_DATE_MUST_BE_AN_ORDERED_DAY:
    "La date de la facture interne doit être une journée de la commande interne qu'elle règle.",
  INTERNAL_ORDER_WEEK_ALREADY_TAKEN:
    "Une autre commande interne existe déjà pour cette semaine. Annulez-la ou corrigez-la plutôt que de rouvrir celle-ci.",
  INTERNAL_ORDER_NOT_CONFIRMED:
    "La commande interne doit être confirmée avant de pouvoir être facturée.",
  DAY_ALREADY_INVOICED:
    "Cette journée a déjà une facture interne. Rejetez ou annulez la facture existante pour la refaire.",
  REMAINING_ITEMS_EMPTY_FOR_DAY:
    "Il n'y a plus rien à facturer pour cette journée.",
  INTERNAL_INVOICE_DATE_IS_NOT_EDITABLE:
    "La date d'une facture interne n'est pas modifiable : elle est celle de la journée commandée qu'elle règle.",
  ONLY_TRANSFER_AUTHOR_CAN_REVERT_TO_DRAFT:
    "Seul le créateur du transfert peut le remettre en brouillon.",
  CANNOT_REVERT_TRANSFER_IN_THIS_STATUS:
    "Ce transfert ne peut plus être remis en brouillon dans son statut actuel.",
  CANNOT_RETURN_PERMANENT_TRANSFER:
    "Un transfert permanent ne peut pas être retourné.",
  CANNOT_RETURN_TRANSFER_IN_CURRENT_STATUS:
    "Ce transfert ne peut pas être retourné dans son statut actuel.",
  CANNOT_RETURN_ITEM_IN_CURRENT_STATUS:
    "Cet équipement ne peut pas être retourné dans le statut actuel du transfert.",
  ITEM_ALREADY_RETURNED: "Cet équipement a déjà été retourné.",
  TRANSFER_NOT_FOUND: "Transfert introuvable.",
  UPDATE_FAILED: "Échec de la mise à jour",
  CREATION_FAILED: "Échec de la création",
  DOWNLOAD_FAILED: "Échec du téléchargement",
  ERROR: "Erreur",
  IS_REQUIRED: "est requis",
  CANNOT_CANCEL_INTERNAL_INVOICE_IN_THIS_STATUS:
    "Cette facture interne ne peut pas être annulée dans son statut actuel.",
  INTERNAL_INVOICE_LOCKED_BY_VALIDATED_WEEKLY_REPORT:
    "Annulation impossible : un rapport hebdomadaire couvrant cette journée est déjà validé.",
  CANCELLATION_REASON_REQUIRED: "Le motif d'annulation est obligatoire.",
  NON_RECEPTION_REASON_REQUIRED:
    "Rien n'a été reçu pour cette journée : indiquez le motif de non-réception.",
  NON_RECEPTION_REASON_INVALID: "Ce motif de non-réception n'est pas reconnu.",
  NON_RECEPTION_REASON_DETAIL_REQUIRED:
    "Précisez le motif lorsque vous choisissez « Autre ».",
  CANCELLATION_REASON_INVALID: "Ce motif d'annulation n'est pas reconnu.",
  CANCELLATION_REASON_DETAIL_REQUIRED:
    "Précisez le motif lorsque vous choisissez « Autre ».",
  USER_NOT_ALLOWED_TO_CANCEL_INTERNAL_INVOICE:
    "Vous n'êtes pas autorisé à annuler cette facture interne.",
  REJECTION_REASON_REQUIRED: "Le motif du refus est obligatoire.",
  REJECTION_REASON_INVALID: "Ce motif de refus n'est pas reconnu.",
  REJECTION_REASON_DETAIL_REQUIRED:
    "Précisez le motif lorsque vous choisissez « Autre ».",
  USER_NOT_ALLOWED_TO_REJECT_INTERNAL_ORDER:
    "Vous n'êtes pas autorisé à refuser cette commande interne.",
};
